<template lang="pug">
  SspLayout(area="core")
    h1.page-header(v-if="organization")
      i.fa.fa-file-text-o &nbsp; {{organization.name}}
    SspSaveForm(@onSubmit="save" :saving="saving")
      .row(v-if="cfg")
        .col-md-6
          .panel.panel-default
            .panel-heading
              h3.panel-title KCEngine
            .panel-body
              .container-fluid
                .row
                  label.col-sm-8 Code default length
                .row
                  .col-sm-12
                    input.form-control.code-default-length-input(type="number" v-model="cfg.KCENGINE_DEFAULT_CODE_LENGTH")
                .row
                  label.col-sm-8 Default code case
                .row
                  .col-sm-12
                    select.form-control(id="default-codecase-select" v-model="cfg.KCENGINE_DEFAULT_CODE_CASE")
                      option(value='UPPERCASE') UPPERCASE
                      option(value='LOWERCASE') lowercase
          .panel.panel-default
            .panel-heading
              h3.panel-title UI customization
            .panel-body
              .container-fluid
                .row
                  label.col-sm-8 Custom UI
                .row
                  .col-sm-12
                    select.form-control(id="custom-ui" v-model="cfg.CUSTOM_UI")
                      option(value="true") true
                      option(value="false") false
        .col-md-6
          .panel.panel-default
            .panel-heading
              h3.panel-title Security
            .panel-body
              .container-fluid
                .row
                  label.col-sm-8 Max failed login attempts
                .row
                  .col-sm-12
                    input.form-control.max-login-attempts-input(type="number" v-model="cfg.MAX_FAILED_LOGIN_ATTEMPTS")

        .col-md-6
          .panel.panel-default
            .panel-heading
              h3.panel-title Metadata
            .panel-body
              .container-fluid
                .row
                  label.col-sm-8 Validate json
                .row
                  .col-sm-12
                    select.form-control(id="validate-json" v-model="cfg.METADATA_VALIDATE_JSON")
                      option(value="true") true
                      option(value="false") false
          .panel.panel-default
            .panel-heading
              h3.panel-title User
            .panel-body
              .container-fluid
                .row
                  label.col-sm-8 Default timezone
                .row
                  .col-sm-12
                    TimezonePicker#timezone(v-model="cfg.USER_DEFAULT_TIMEZONE")

</template>
<script>
import miniToastr from 'mini-toastr'
import TimezonePicker from '@/components/common/TimezonePicker'
import Security from '@/service/apis/Security'

export default {
  data: () => ({
    saving: false,
    organization: null,
    cfg: null
  }),
  created() {
    Security.userInfo()
      .then((r) => {
        this.organization = r.data.organization
      })
      .catch((e) => { this.$emit('error', e) })

    Security.getConfiguration()
      .then((resp) => {
        const cfg = {}
        for (let i = 0; i < resp.data.entry.length; i += 1) {
          cfg[resp.data.entry[i].key] = resp.data.entry[i].value
        }
        this.cfg = cfg;
      })
      .catch((e) => { this.$emit('error', e) })
  },
  methods: {
    save() {
      this.saving = true
      const newCfg = []
      Object.keys(this.cfg)
        .forEach((key) => {
          newCfg.push({ key, value: this.cfg[key] })
        })

      const timeZoneindex = newCfg.findIndex((arr) => arr.key === 'USER_DEFAULT_TIMEZONE')
      newCfg[timeZoneindex] = { key: 'USER_DEFAULT_TIMEZONE', value: this.cfg.USER_DEFAULT_TIMEZONE.value }

      Security.updateConfiguration({ entry: newCfg })
        .then(() => {
          miniToastr.success('Configuration successfully updated')
          this.$router.push({ name: 'configuration' })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    }
  },
  components: {
    TimezonePicker
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/security/ConfigurationEdit.vue